import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInitialStateStudyYears, IStudyYearsPayload } from "../types";
import { GetDeleteStudy, GetStudyYears } from "./thunk";

const initialState: IInitialStateStudyYears = {
    studyYearsData: [],
    studyRestoreData: [],
    selectedStudyIDs: [],
    isViewStudyRestore: false,
    isLoadingStudyYears: false,
};

const studyYearsSlice = createSlice({
    name: "studyYears",
    initialState,
    reducers: {
        setStudyYears: (state, action: PayloadAction<IStudyYearsPayload[]>) => {
            if (Array.isArray(action.payload)) {
                state.studyYearsData = action.payload;
            }
        },

        deletedStudyYears: (state, action: PayloadAction<number>) => {
            state.studyYearsData = state.studyYearsData.filter(elem => elem.id !== action.payload);
        },
        updateStudyYears: (state, action: PayloadAction<IStudyYearsPayload>) => {
            const updateData = action.payload;

            state.studyYearsData = state.studyYearsData.map((elem: IStudyYearsPayload) => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },
        setStudyRestoreData: (state, action) => {
            state.studyRestoreData = action.payload;
        },

        deletedRestoreStudy: (state, action) => {
            state.studyRestoreData = state.studyRestoreData.filter(elem => elem.id !== action.payload);
        },
        setIsViewStudyRestore: state => {
            state.isViewStudyRestore = !state.isViewStudyRestore;
        },
        setSelectedStudyIDs: (state, action) => {
            state.selectedStudyIDs = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetStudyYears.pending, state => {
                state.isLoadingStudyYears = true;
            })
            .addCase(GetStudyYears.fulfilled, state => {
                state.isLoadingStudyYears = false;
            })
            .addCase(GetStudyYears.rejected, state => {
                state.isLoadingStudyYears = false;
            })
            .addCase(GetDeleteStudy.pending, state => {
                state.isLoadingStudyYears = true;
            })
            .addCase(GetDeleteStudy.fulfilled, state => {
                state.isLoadingStudyYears = false;
            })
            .addCase(GetDeleteStudy.rejected, state => {
                state.isLoadingStudyYears = false;
            });
    },
});

export const {
    setStudyYears,
    deletedStudyYears,
    updateStudyYears,
    setIsViewStudyRestore,
    deletedRestoreStudy,
    setStudyRestoreData,
    setSelectedStudyIDs,
} = studyYearsSlice.actions;
export default studyYearsSlice;
